import { lazy, Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { AdminShell } from './AdminShell'
import { DashboardPage } from '../pages/DashboardPage'
import { OrdersPage } from '../pages/OrdersPage'
import { OrderPage } from '../pages/OrderPage'
import { NotificationsPage } from '../pages/NotificationsPage'
import { ProductsPage } from '../pages/ProductsPage'
import { ProductPage } from '../pages/ProductPage'
import { CategoriesPage } from '../pages/CategoriesPage'
import { CategoryPage } from '../pages/CategoryPage'
import { StoriesPage } from '../pages/StoriesPage'
import { StoryPage } from '../pages/StoryPage'
import { NewsListPage } from '../pages/NewsListPage'
import { NewsPage } from '../pages/NewsPage'
import { ReviewsPage } from '../pages/ReviewsPage'
import { CustomersPage } from '../pages/CustomersPage'
import { CustomerPage } from '../pages/CustomerPage'
import { CustomerEditPage } from '../pages/CustomerEditPage'
import { StoresPage } from '../pages/StoresPage'
import { StorePage } from '../pages/StorePage'
import { StoreEditPage } from '../pages/StoreEditPage'
import { AdminsPage } from '../pages/AdminsPage'
import { StaffPage } from '../pages/StaffPage'
import { RolesPage } from '../pages/RolesPage'
import { RolePage } from '../pages/RolePage'
import { IntegrationsPage } from '../pages/IntegrationsPage'
import { IntegrationPage } from '../pages/IntegrationPage'
import { SettingsPage } from '../pages/SettingsPage'
import { NotFoundPage } from '../pages/NotFoundPage'

// Страница дизайн-системы грузится отдельным чанком: её стили (новые токены и
// кит) не попадают на рабочие экраны, пока система не подключена к ним.
const DesignSystemPage = lazy(() =>
  import('../design-system/DesignSystemPage').then((m) => ({ default: m.DesignSystemPage })),
)

/**
 * По разделу на модуль — порядок и адреса совпадают с меню прототипа
 * (admin.html › MODULES). Пункт виден, только если у роли есть `r`; сам доступ
 * проверяет каркас, а не роутер, чтобы «нет доступа» выглядел одинаково и при
 * переходе по ссылке.
 */
export const routes: RouteObject[] = [
  // Справочник для команды: без входа и вне меню — в нём нет данных.
  {
    path: 'design-system',
    element: (
      <Suspense fallback={null}>
        <DesignSystemPage />
      </Suspense>
    ),
  },
  {
    element: <AdminShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'orders/:id', element: <OrderPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'products', element: <ProductsPage /> },
      { path: 'products/:id', element: <ProductPage /> },
      { path: 'categories', element: <CategoriesPage /> },
      { path: 'categories/new', element: <CategoryPage /> },
      { path: 'categories/:id', element: <CategoryPage /> },
      { path: 'stories', element: <StoriesPage /> },
      { path: 'stories/new', element: <StoryPage /> },
      { path: 'stories/:id', element: <StoryPage /> },
      { path: 'news', element: <NewsListPage /> },
      { path: 'news/new', element: <NewsPage /> },
      { path: 'news/:id', element: <NewsPage /> },
      { path: 'reviews', element: <ReviewsPage /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'customers/:id', element: <CustomerPage /> },
      { path: 'customers/:id/edit', element: <CustomerEditPage /> },
      { path: 'stores', element: <StoresPage /> },
      { path: 'stores/:id', element: <StorePage /> },
      { path: 'stores/new', element: <StoreEditPage /> },
      { path: 'stores/:id/edit', element: <StoreEditPage /> },
      { path: 'admins', element: <AdminsPage /> },
      { path: 'admins/:id', element: <StaffPage /> },
      { path: 'roles', element: <RolesPage /> },
      { path: 'roles/:id', element: <RolePage /> },
      { path: 'integrations', element: <IntegrationsPage /> },
      { path: 'integrations/:id', element: <IntegrationPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
